module.exports = __webpack_public_path__ + "assets/fafb5d7127ac0858d43aad0747920942.mp3";